<template>

  <el-collapse-item name="绘制" title="绘制">
    <h5>图形</h5>

    <slot></slot>

    <h5>文本</h5>

    <el-form-item label="显示文本">
      <el-switch v-model="ele.option.seriesLabel.isShowLabel" active-color="#55aaff" inactive-color="#cfcfcf" @change="handleChangeShowLabel"></el-switch>
    </el-form-item>

    <el-form-item label="文本颜色">
      <el-color-picker v-model="ele.option.seriesLabel.labelColor"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       @change="handleChangeLabelColor" show-alpha>
      </el-color-picker>
    </el-form-item>

    <el-form-item label="文本字体大小">
      <el-input-number v-model="ele.option.seriesLabel.labelFontSize" @change="handleChangeLabelSize"></el-input-number>
    </el-form-item>

    <el-form-item label="文本位置">
      <el-select v-model="ele.option.seriesLabel.labelPosition" style="width: 120px" @change="handleChangeLabelPosition">
        <el-option label="top" value="top"></el-option>
        <el-option label="left" value="left"></el-option>
        <el-option label="right" value="right"></el-option>
        <el-option label="bottom" value="bottom"></el-option>
        <el-option label="inside" value="inside"></el-option>
        <el-option label="insideLeft" value="insideLeft"></el-option>
        <el-option label="insideRight" value="insideRight"></el-option>
        <el-option label="insideTop" value="insideTop"></el-option>
        <el-option label="insideBottom" value="insideBottom"></el-option>
        <el-option label="insideTopLeft" value="insideTopLeft"></el-option>
        <el-option label="insideBottomLeft" value="insideBottomLeft"></el-option>
        <el-option label="insideTopRight" value="insideTopRight"></el-option>
        <el-option label="insideBottomRight" value="insideBottomRight"></el-option>
      </el-select>
    </el-form-item>

    <h5>文本描边</h5>

    <el-form-item label="文本描边颜色">
      <el-color-picker v-model="ele.option.seriesLabel.labelBorderColor"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       @change="handleChangeLabelBorderColor" show-alpha>
      </el-color-picker>
    </el-form-item>

    <el-form-item label="文本描边大小">
      <el-input-number v-model="ele.option.seriesLabel.labelBorderWidth" @change="handleChangeLabelBorderWidth"></el-input-number>
    </el-form-item>

  </el-collapse-item>

</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods:{
    handleChangeShowLabel() {
      this.ele.option.series.forEach(item => {
        item.label.show = this.ele.option.seriesLabel.isShowLabel;
      })
    },
    handleChangeLabelColor() {
      this.ele.option.series.forEach(item => {
        item.label.color = this.ele.option.seriesLabel.labelColor;
      })
    },
    handleChangeLabelSize() {
      this.ele.option.series.forEach(item => {
        item.label.fontSize = this.ele.option.seriesLabel.labelFontSize;
      })
    },
    handleChangeLabelPosition() {
      this.element.option.series.forEach(item => {
        item.label.position = this.element.option.seriesLabel.labelPosition;
      })
    },
    handleChangeLabelBorderWidth() {
      this.element.option.series.forEach(item => {
        item.label.textBorderWidth = this.element.option.seriesLabel.labelBorderWidth;
      })
    },
    handleChangeLabelBorderColor() {
      this.element.option.series.forEach(item => {
        item.label.textBorderColor = this.element.option.seriesLabel.labelBorderColor;
      })
    },
  }

}

</script>



<style scoped lang="scss">

</style>